import { iconSizes } from '@mds/tokens';
import { buttonClasses, svgIconClasses, type Components } from '@mui/material';
import type { Theme } from './utils';

const buttonIconSelector = (sizeClass: string) =>
  `.${sizeClass} .${buttonClasses.startIcon} &.${svgIconClasses.fontSizeMedium}, .${sizeClass} .${buttonClasses.endIcon} &.${svgIconClasses.fontSizeMedium}`;

export const MuiSvgIcon: Components<Theme>['MuiSvgIcon'] = {
  styleOverrides: {
    root: {
      [buttonIconSelector(buttonClasses.sizeSmall)]: {
        fontSize: iconSizes.sm,
      },
      [buttonIconSelector(buttonClasses.sizeMedium)]: {
        fontSize: iconSizes.md,
      },
      [buttonIconSelector(buttonClasses.sizeLarge)]: {
        fontSize: iconSizes.lg,
      },
    },
  },
  variants: [
    {
      props: { fontSize: '2xs' },
      style: { fontSize: iconSizes['2xs'] },
    },
    {
      props: { fontSize: 'xs' },
      style: { fontSize: iconSizes.xs },
    },
    {
      props: { fontSize: 'small' },
      style: { fontSize: iconSizes.sm },
    },
    {
      props: { fontSize: 'sm' },
      style: { fontSize: iconSizes.sm },
    },
    {
      props: { fontSize: 'medium' },
      style: { fontSize: iconSizes.md },
    },
    {
      props: { fontSize: 'md' },
      style: { fontSize: iconSizes.md },
    },
    {
      props: { fontSize: 'large' },
      style: { fontSize: iconSizes.lg },
    },
    {
      props: { fontSize: 'lg' },
      style: { fontSize: iconSizes.lg },
    },
    {
      props: { fontSize: 'xl' },
      style: { fontSize: iconSizes.xl },
    },
    {
      props: { fontSize: '2xl' },
      style: { fontSize: iconSizes['2xl'] },
    },
  ],
};
